namespace Areas.Vendor.Edit {
    "use strict";

    let tabItems = Areas.createTabsWithSameAction("Vendor", "Edit",
        ["Profile", "Contact", "Contract"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }


    export function updateVendor() {
        const form = $("#VendorForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Vendor/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function returnToListFromTab() {
        var linkInfo = "/Vendor/List/Active";
        location.href = linkInfo;

    }

    export function vendorLookupItem(itemData: any, itemIndex: any, itemElement: any) {
        if (itemData.isActive) {
            itemElement.append(
                `<div><span class="collookupspanid">${itemData.vendorId}</span>${itemData.vendorName}</div>`);
        } else if (itemData.isBarred) {
            itemElement.append(
                `<div style='color:red;font-style:italic'><span class="collookupspan">${itemData.vendorId}</span>${
                itemData.vendorName} - BARRED<div>`);
        } else
            itemElement.append(
                `<div style='color:red;font-style:italic'><span class="collookupspan">${itemData.vendorId}</span>${
                itemData.vendorName} - Inactive<div>`);
        }

}


